import { create } from 'zustand';

interface FloatingAIChatState {
  isOpen: boolean;
  initialMessage?: string;
  open: (prompt?: string) => void;
  close: () => void;
}

export const useFloatingAIChat = create<FloatingAIChatState>((set) => ({
  isOpen: false,
  initialMessage: undefined,
  open: (prompt) => set({ isOpen: true, initialMessage: prompt }),
  close: () => set({ isOpen: false, initialMessage: undefined }),
}));
